import { render, staticRenderFns } from "./HlsPlayer.vue?vue&type=template&id=06a53c27&scoped=true&"
import script from "./HlsPlayer.vue?vue&type=script&lang=js&"
export * from "./HlsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./HlsPlayer.vue?vue&type=style&index=0&id=06a53c27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a53c27",
  null
  
)

export default component.exports